import { FC } from "react";

import styled from "@emotion/styled";
import { cmsImageUrl } from "src/lib/cmsImageUrl";

// Serve WebP at reduced quality instead of the raw 900x826 JPEG. The container
// size varies (fills its parent), so we keep the native dimensions and only
// change format/quality.
const mealInsightsFtuxBg = cmsImageUrl(
  "5578925647ec442e116a1af2f942a3c1dd7128ba-900x826.jpg",
  { autoFormat: true, quality: 80 }
);

const Photo = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center top;
  pointer-events: none;
`;

const Overlay = styled.div`
  position: absolute;
  width: 64rem;
  height: 44rem;
  transform: rotate(166.343deg);
  right: -27.5rem;
  bottom: -21rem;
  pointer-events: none;
  background: var(
    --meal-insights-hero-overlay,
    radial-gradient(
      50.82% 50.82% at 53.19% 49.18%,
      #ffdeb8 18.75%,
      #fbdef3 47.92%,
      rgba(255, 253, 244, 0) 100%
    )
  );
`;

const MealHeroBackground: FC = () => (
  <>
    <Photo src={mealInsightsFtuxBg} alt="" aria-hidden="true" />
    <Overlay aria-hidden="true" />
  </>
);

export default MealHeroBackground;
